// ToolLayout — обёртка вокруг отдельного tool'а с переключателем «Генерация» / «История».
//
// Контракт (PRD §3.1):
//   - URL /tools/{slug} — режим генерации (default).
//   - URL /tools/{slug}/history — режим истории.
//   - Если tool.has_history === false → переключатель не показывается.
//   - Состояние формы переживает переключение (поскольку компоненты unmount'ятся,
//     это обеспечивается auto-save в localStorage на стороне самой формы).
import { Segmented, Typography } from "antd";
import { EditOutlined, HistoryOutlined } from "@ant-design/icons";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

interface Props {
  toolSlug: string;
  toolName: string;
  hasHistory: boolean;
}

export function ToolLayout({ toolSlug, toolName, hasHistory }: Props) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Trailing slash safe: react-router может или не может добавлять / в конец.
  const normalizedPath = pathname.replace(/\/+$/, "");
  const isHistory = normalizedPath.endsWith("/history");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,
          gap: 16,
        }}
      >
        <Typography.Title level={3} style={{ margin: 0 }}>
          {toolName}
        </Typography.Title>
        {hasHistory && (
          <Segmented
            value={isHistory ? "history" : "generation"}
            onChange={(value) => {
              if (value === "history") navigate(`/tools/${toolSlug}/history`);
              else navigate(`/tools/${toolSlug}`);
            }}
            options={[
              { label: "Генерация", value: "generation", icon: <EditOutlined /> },
              { label: "История", value: "history", icon: <HistoryOutlined /> },
            ]}
          />
        )}
      </div>
      <Outlet />
    </div>
  );
}
